import { SalesDespatchItemDetails } from './sales-despatch-item-details';
import { SalesDespatchNoteStatusItem } from './sales-despatch-note-status-item';

export interface SalesDespatchNoteDetails {
  id: string;
  despatchNoteNo: number;
  despatchDate: Date;
  createdBy: string;
  customerId: string;
  customerKey: string;
  customerName: string;
  customerAddressMultiLine: string;
  customerContactId: string;
  deliveryAddressId: string;
  deliveryAddressMultiLine: string;
  notes: string;
  modeOfTransportId: string;
  deliveryTermId: string;
  portId: string;
  shipperSupplierId: string;
  shippingMarks: string;
  trackingNo: string;
  salesDespatchPrintedById: string;
  salesDespatchPrintedDate: Date;
  salesDespatchPrinted: string;
  salesOrderNo: string;
  grossKgs: number;
  nettKgs: number;
  salesDespatchNoteStatusId: string;
  documentNotes: string;
  dateOfProof: Date;
  dateReceived: Date;
  recipientDetails: string;
  deliveryAddresseeId: string;
  deliveryAddressee: string;
  shipperInterface: boolean;
  shipperInterfaceId: string;

  salesDespatchItems: SalesDespatchItemDetails[];
  salesDespatchNoteStatusItems: SalesDespatchNoteStatusItem[];
}
